/*global REACT_APP_API_BASE_URL:true*/

/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function fetchAllUsersPagination(_, params) {
  let sorting = params.sorter ? params.sorter.split(":") : "";
  let filtering = params.filters ? params.filters : null;
  let paramsPayload = {
    PageNumber: params.current,
    PageSize: params.pageSize,
    userType: params.userType ? params.userType : 0,
    GetAll: params.GetAll,
  };
  if (sorting) {
    (paramsPayload.column = sorting[0]), (paramsPayload.order = sorting[1]);
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount++;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.search = params.searchValue.toLowerCase().trim();
  }
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts/Users/Paginate`, {
    params: paramsPayload,
  });

  return await result;
}

export async function fetchAllUsers(_, adminLevel) {
  let paramsPayload = {};
  if (adminLevel) {
    paramsPayload.adminLevel = adminLevel;
  }
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts/Users`, {
    params: paramsPayload,
  });

  return (await result).data;
}

export async function queryCurrent() {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts/Session/Users`, {});
  return (await result).data;
}

export async function getUser(_, userId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts`, {
    params: { userId },
  });

  return (await result).data;
}

export async function sendContactUsEmail(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/contact-us`, {
    method: "POST",
    data: payload,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getRMIS(_, dotNumber, entityId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities/Rmis`, {
    params: { queryId: dotNumber, entityId },
  });

  return (await result)?.data;
}

export async function updateEntityInfo(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Accounts/Dealer`, {
    method: "PATCH",
    data: payload,
  });

  return (await result)?.data;
}

export async function checkEmailInUse(email) {
  email = encodeURIComponent(email);
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Accounts/EmailExist?email=${email}`);

  if (result.length === 0) {
    // 404 status response, email not in use by a user or a contact
    return Promise.resolve("Email not in use in system");
  }

  if (result.response.status === 200) {
    // 200 status response, email in use by a user or a contact
    return Promise.reject(result.data);
  }

  return Promise.reject("Error checking email");
}

export async function addDealerUserAnon(payload, entityId, defaultRole, emailLinkId, autoGenTempPassword) {
  let params = {
    entityId,
    autoGenTempPassword,
  };

  if (defaultRole !== null && defaultRole !== undefined) {
    params.defaultRole = defaultRole;
  }

  if (emailLinkId !== null && emailLinkId !== undefined) {
    params.emailLinkId = emailLinkId;
  }

  const result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Accounts/User/Anon`, {
    method: "POST",
    params,
    data: payload,
  });

  return (await result)?.data;
}

export async function addTransporterUserAnon(payload, entityId, defaultRole, emailLinkId, autoGenTempPassword) {
  let params = {
    entityId,
    autoGenTempPassword,
  };

  if (defaultRole !== null && defaultRole !== undefined) {
    params.defaultRole = defaultRole;
  }

  if (emailLinkId !== null && emailLinkId !== undefined) {
    params.emailLinkId = emailLinkId;
  }

  const result = request(`${REACT_APP_API_BASE_URL}/api/Transporter/Accounts/User/Anon`, {
    method: "POST",
    data: payload,
    params,
  });

  return (await result)?.data;
}

export async function createDealer(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Accounts/Entities`, {
    method: "POST",
    data: payload,
  });

  return (await result).data;
}

export async function resetPassword(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts/ResetPassword`, {
    method: "PUT",
    data: payload,
  });

  return (await result).data;
}

export async function deleteUser(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Accounts/Users`, {
    method: "DELETE",
    data: payload,
  });

  return (await result).data;
}

export async function deleteUserOnly(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Accounts/Users/DeleteUserOnly`, {
    method: "DELETE",
    data: payload,
  });

  return result?.response?.status === 204;
}

export async function addTransporterEntity(_, entityId, userId, defaultRole, emailLinkId) {
  let params = {
    userId,
  };

  if (defaultRole !== null && defaultRole !== undefined) {
    params.defaultRole = defaultRole;
  }

  if (emailLinkId !== null && emailLinkId !== undefined) {
    params.emailLinkId = emailLinkId;
  }

  const result = request(`${REACT_APP_API_BASE_URL}/api/Transporter/Accounts/Entities/${entityId}/Add`, {
    method: "PUT",
    params,
  });

  return (await result)?.data;
}

export async function addDealerEntity(_, entityId, userId, defaultRole, emailLinkId) {
  let params = {
    userId,
  };

  if (defaultRole !== null && defaultRole !== undefined) {
    params.defaultRole = defaultRole;
  }

  if (emailLinkId !== null && emailLinkId !== undefined) {
    params.emailLinkId = emailLinkId;
  }

  const result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Accounts/Entities/${entityId}/Add`, {
    method: "PUT",
    params,
  });

  return (await result)?.data;
}

export async function getAllEntities(_, type) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities`, {
    params: { type },
  });

  return (await result).data;
}

export async function getAllEntitiesPagination(_, type, params) {
  let sorting = params.sorter ? params.sorter.split(":") : "";
  let filtering = params.filters ? params.filters : null;
  let paramsPayload = {
    PageNumber: params.current,
    PageSize: params.pageSize,
    type,
    GetAll: params.GetAll,
  };
  if (sorting) {
    paramsPayload.column = sorting[0];
    paramsPayload.order = sorting[1];
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount++;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.search = params.searchValue.toLowerCase().trim();
  }

  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities/Paginate`, {
    params: paramsPayload,
  });

  return await result;
}

export async function getSingleEntities(_, entityId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities/${entityId}`, {});

  return (await result)?.data;
}

export async function getSingleEntitiesAnon(entityId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities/${entityId}/Anon`);

  return (await result)?.data;
}

export async function removeEntityConnection(_, entityId, userId) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Entities`, {
    method: "DELETE",
    params: { entityId, userId },
  });

  return result?.response?.status === 204;
}

export async function fetchUsersUnderEntity(_, entityId, moreInfo = false) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Entities/${entityId}/Users`, {
    params: {
      moreInfo,
    },
    // headers: {
    //   Authorization: `Bearer ${user.access_token}`,
    // },
  });

  return (await result).data;
}

export async function updateRoles(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Roles/Toggle`, {
    method: "PATCH",
    data: payload,
  });

  return result ? result : { error: true };
}

export async function queryNotices() {
  return request("/api/notices");
}
export async function query() {
  return request("/api/users");
}

export async function validateEmailInvite(payload) {
  const { inviteId, email } = payload;
  const result = await request(`${REACT_APP_API_BASE_URL}/api/EmailLinks/GetEmailLinksByEmail/${inviteId}/${email}`, {
    method: "POST",
  });

  if (result?.response?.ok && result?.response?.status === 200 && result?.data) {
    return result;
  }

  return { error: true };
}

export async function getUserWatchlist(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Watchlist/GetUserWatchlist`, {
    params: {
      userId: payload?.userId,
    },
  });

  return (await result).data;
}

export async function addUserWatchlistItem(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Watchlist/AddUserWatchlistItem`, {
    method: "POST",
    data: payload,
  });

  if (result?.response?.status === 200) {
    return true;
  }
}

export async function clearUserWatchlist(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Watchlist/ClearUserWatchlist`, {
    method: "DELETE",
    params: {
      userId: payload?.userId,
    },
  });

  if (result?.response?.status === 200) {
    return true;
  }
}

export async function deleteUserWatchlistItem(_, payload) {
  const { userId, objectId } = payload;

  const result = await request(`${REACT_APP_API_BASE_URL}/api/Watchlist/DeleteWatchlistItem/${userId}/${objectId}`, {
    method: "DELETE",
  });

  if (result?.response?.status === 200) {
    return true;
  }
}

export async function getAppConfigData() {
  const response = await request(`${REACT_APP_API_BASE_URL_NEW}/api/abp/application-configuration`, {
    method: "GET",
    params: {
      IncludeLocalizationResources: true,
    },
  });
  return response.data;
}
